import apiUrl from "./config/config";
import axios from "axios";

class warrantyApi
{

  //Get a warranty by serial number
  static async getWarrantyBySerialNumber(serial)
  {

    try
    {

      const response = await axios(apiUrl + `warranty/serial/${serial}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}
export default warrantyApi;
